var questionState = 0;
var quizActive = true;
var userStats = [0, 0, 0, 0, 0, 0];
var questionText = [
    "How would you describe your skin type?",
    "To help us with your recommendation, what is your age?",
    "What is your gender?",
    "How would you describe your main beauty goal?",
    "Are you pregnant or breastfeeding?"
];
var answerText = [
    ["Normal skin", "Combination skin", "Oily or acne prone skin", "Sensitive skin", "Dull or dry skin", "Dehydrated", "Eczema or psoriasis prone", "Early signs of aging", "Mature skin"],
    ["18-24", "25-30", "31-40", "41-50", "51-60", "60+"],
    ["Female", "Male", "Prefer not to say"],
    ["Skin glow & radiance", "Reduce fine lines & wrinkles", "Help acne flare-ups", "Help dry skin flare-ups", "Thicker, fuller hair", "Stronger nails", "Revive menopausal skin & hair"],
    ["Yes", "No"]
];
var products = [
    {
        name: "Original",
        image: "https://cdn.shopify.com/s/files/1/0739/5816/2730/files/UK_OG_copy_a9cdbd8f-5593-4434-b3a0-7b415b54be6e.jpg?v=1722853858",
        link: "https://us.revivecollagen.com/products/revive-collagen-hydrolysed-marine-collagen-drink-us"
    },
    {
        name: "Enhanced Plus",
        image: "https://cdn.shopify.com/s/files/1/0739/5816/2730/files/UK_EP_copy_91d0c96c-9113-4e42-8c38-4631a3e1a2ec.jpg?v=1722853858",
        link: "https://us.revivecollagen.com/products/revive-collagen-enhanced-plus-hydrolysed-marine-collagen-drink-us"
    }
];
var results = document.getElementById("rcq-results");
var quiz = document.getElementById("rcq-quiz");
var loadingContainer = document.getElementById("rcq-loading-container");
var productRecommendation = document.getElementById("rcq-product-recommendation");
var buttonElement = document.getElementById("rcq-button");
buttonElement.addEventListener("click", changeState);

// Preload product images
function preloadImages() {
    products.forEach(product => {
        const img = new Image();
        img.src = product.image;
    });
}

// Call this function when the page loads
window.onload = preloadImages;

function changeState() {
    if (quizActive) {
        animateQuestionOut();
        setTimeout(() => {
            initText(questionState);
            questionState++;
            animateQuestionIn();
        }, 100);
    } else {
        setCustomPage();
    }
    scrollToQuiz();
}

function initText(question) {
    var answerSelection = "";
    for (var i = 0; i < answerText[question].length; i++) {
        answerSelection += "<li><input type='radio' name='question" +
            (question + 1) + "' onClick='setAnswer(" + i + ")' id='option" + question + "_" + i + "'><label for='option" + question + "_" + i + "' class='rcq-quiz-btn'>" + answerText[question][i] + "</label></li>";
    }
    document.getElementById("rcq-questions").innerHTML = questionText[question];
    document.getElementById("rcq-answers").innerHTML = answerSelection;
    buttonElement.style.display = "none";
    document.getElementById("rcq-back-button-container").style.display = "block";
    document.getElementById("rcq-quiz-title").style.display = "none";
    resetButtonStyles();
}

function resetButtonStyles() {
    var buttons = document.querySelectorAll('#rcq-answers li, #rcq-button');
    buttons.forEach(function(button) {
        button.style.opacity = '1';
    });
}

function setAnswer(input) {
    if (questionState === 0) {
        changeState();
    } else if (questionState === 1) {
        changeState();
    } else if (questionState === 2) {
        changeState();
    } else if (questionState === 3) {
        userStats[3] = input; // Store the beauty goal answer
        changeState(); // Go to next question
    } else if (questionState === 4) {
        changeState(); // Go to next question
    } else if (questionState === 5) { // Are you pregnant or breastfeeding?
        if (input === 0) {
            showLoadingScreen(0); // Original product recommendation for "Yes"
        } else if (input === 1) {
            // Proceed based on previous beauty goal answer
            switch (userStats[3]) {
                case 0:
                    showLoadingScreen(0, 1); // Skin glow & radiance
                    break;
                case 1:
                    showLoadingScreen(1); // Fine lines & wrinkles
                    break;
                // Add other cases as needed
                default:
                    showLoadingScreen(1); // Default case if no match
                    break;
            }
        }
    }
    scrollToQuiz();
}


function goBack() {
    if (results.style.display === "block") {
        results.style.display = "none";
        quiz.style.display = "block";
        questionState -= 1;
    } else if (questionState === 1) {
        // Reset to the initial quiz start screen
        questionState = 0;
        document.getElementById("rcq-quiz-title").style.display = "block";
        document.getElementById("rcq-questions").innerHTML = "Are you ready to start the quiz?";
        document.getElementById("rcq-answers").innerHTML = "";
        buttonElement.style.display = "inline-block";
        document.getElementById("rcq-back-button-container").style.display = "none";

        // Apply the fade-in animation to the start page
        quiz.classList.add('rcq-fade-in-start');
    } else if (questionState > 1) {
        questionState -= 2;
        if (questionState < 0) questionState = 0;
        animateQuestionOut();
        setTimeout(() => {
            initText(questionState);
            questionState++;
            animateQuestionIn();
        }, 100);
    }
    scrollToQuiz();
}

function animateQuestionOut() {
    var quizContainer = document.getElementById("rcq-quiz-container");
    quizContainer.classList.add("fade-out");
    setTimeout(() => {
        quizContainer.classList.remove("fade-out");
    }, 100);
}

function animateQuestionIn() {
    var quizContainer = document.getElementById("rcq-quiz-container");
    quizContainer.classList.add("fade-in");
    setTimeout(() => {
        quizContainer.classList.remove("fade-in");
    }, 500);
}

function displayCustomPage(...productIndices) {
    var productHTML = '<div class="rcq-product-container">';
    productIndices.forEach(index => {
        var product = products[index];
        productHTML += `
            <div class="rcq-product">
                <h4>${product.name}</h4>
                <a href="${product.link}" class="rcq-product-link">
                    <img src="${product.image}" alt="${product.name}" class="rcq-product-image">
                </a>
                <a href="${product.link}" class="rcq-btn rcq-btn-primary">Shop Now</a>
            </div>
        `;
    });
    productHTML += '</div>';
    productRecommendation.innerHTML = productHTML;
    loadingContainer.classList.add("fade-out");
    setTimeout(() => {
        loadingContainer.style.display = "none";
        results.style.display = "block";
        results.classList.add("fade-in-results");
        setTimeout(() => {
            results.classList.remove("fade-in-results");
        }, 500);
    }, 500);
    document.getElementById("rcq-back-button-container").style.display = "block";
}

function showLoadingScreen(...productIndices) {
    quiz.style.display = "none";
    loadingContainer.style.display = "block";
    setTimeout(() => {
        displayCustomPage(...productIndices);
    }, 2000);
}

function scrollToQuiz() {
    var quizContainer = document.getElementById("rcq-quiz-container");
    quizContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

document.getElementById("rcq-back-button").addEventListener("click", goBack);
